


















import { Component, Vue, Prop } from "vue-property-decorator";
import router from '@/router/router'

import store from "@/store";
import { Section } from "@/common/interface";
import GachaTabs from "./GachaTabs.vue";
import { Getter, Action } from "vuex-class";

@Component({
    components: {
      'gacha-tabs':GachaTabs
    }
})
export default class ActivityChoise extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
  @Action("changeGachaParameter") changeGachaParameter!: Function;
  get sectionConf() {
    return store.getters.section;
  }
  linkToPlayExplanation(){
    this.changeGachaParameter({'showPlayDesc':true});
  }
}
